<template>
  <div>
    <div class="w-100 h-100">
      <Nav :rolname="rolname" />
    </div>
    <div class="content h-100" style="background: white">
      <Home
        v-if="page == 'home'"
        @changePage="changePage"
        @mtdBackCampus="mtdBackCampus"
      />
      <Compras v-if="page == 'compras'" @returnHome="returnHome" />
      <Stock v-if="page == 'stock'" @returnHome="returnHome" />
      <Productos v-if="page == 'productos'" @returnHome="returnHome" />
      <LisCompras v-if="page == 'lisCompras'" @returnHome="returnHome" />
      <Requerimiento v-if="page == 'requerimiento'" @returnHome="returnHome" />
    </div>
    <div class="footer">
      <FooterVue @changePage="changePage" :pageView="page" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Nav from "../../components/Logis/Nav.vue";
import FooterVue from "../../components/Logis/Footer.vue";
import Home from "../../components/Logis/Home.vue";
import Compras from "../../components/Logis/pages/Compras.vue";
import Stock from "../../components/Logis/pages/Stock.vue";
import Productos from "../../components/Logis/pages/Maintenance.vue";
import LisCompras from "../../components/Logis/pages/LisCompras.vue";
import Requerimiento from "@/components/Logis/pages/Requerimiento.vue";

export default {
  name: "LogisView",
  components: {
    Nav,
    FooterVue,
    Home,
    Compras,
    Stock,
    Productos,
    LisCompras,
    Requerimiento
  },
  data() {
    return {
      prefix: 'logistica',
      area: "Logistica",
      bead: {},
      verifBead: false,
      boxes: [],
      page: "home",
      client: null,
      filter: {},
    };
  },
  props: {
    rolname: String,
  },
  created() {
    this.rol_name = this.rolname;
  },
  methods: {
    ...mapActions(["get", "post"]),

    changePage: function (page) {
      this.page = page;
    },
    returnHome: function () {
      this.page = "home";
    },
    mtdBackCampus: function () {
      this.$emit("mtdBackCampus");
    },
    mtdBackRol: function () {
      this.$emit("mtdBackRol");
    },
  },
};
</script>
